import React from 'react';

type WorkflowFormErrorBannerProps = {
  message?: string | null;
};

export const WorkflowFormErrorBanner: React.FC<
  WorkflowFormErrorBannerProps
> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="mt-2 border border-rose-200 bg-rose-50 text-rose-700 rounded px-3 py-2 text-sm">
      {message}
    </div>
  );
};

export default WorkflowFormErrorBanner;
